import { useSelector } from 'react-redux';
import { getDefaultModelId } from 'store/reducers/projectSettings/getters';

export const useModelIdValue = (modelId: string | null) => {
  const defaultModelValue = useSelector(getDefaultModelId);

  return modelId || defaultModelValue || '';
};
